export default __webpack_public_path__ + "static/media/vpThirdParty.d7955d1b.svg";